function compareDate(date1, date2) {
  var c = date1.diff(date2)
  return (c === 0 ? 'equal' : (c > 0 ? 'greater' : 'lesser'))
}

export { compareDate }
